import React, { useState, useEffect, useContext } from "react";
import "../../../assets/css/admin/dashboard/admincontact/contactmanagement.css";
import AdminMasterLayout from "layouts/AdminMasterLayout";
import AppContext from "context/AppContext";
import axios from "axios";

// ─── Icons ─────────────────────────────────────────────────────
const SearchIcon = () => (
  <svg
    className="cm-search-icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);
const ChevronIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
);
const EyeIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);
const TrashIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6" />
    <path d="M10 11v6M14 11v6M9 6V4h6v2" />
  </svg>
);
const UserIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
  >
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);
const MailIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
  >
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);
const PhoneIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
  >
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.41 2 2 0 0 1 3.6 1.25h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.84a16 16 0 0 0 6.29 6.29l.96-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);
const MsgIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
  >
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
);
const CloseIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);
const SendIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <line x1="22" y1="2" x2="11" y2="13" />
    <polygon points="22 2 15 22 11 13 2 9 22 2" />
  </svg>
);
const ReplyIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <polyline points="9 17 4 12 9 7" />
    <path d="M20 18v-2a4 4 0 0 0-4-4H4" />
  </svg>
);
const CheckIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

// ─── Sample Data ───────────────────────────────────────────────
// const INITIAL_CONTACTS = [
//   { id: 1,  avatar: 'https://i.pravatar.cc/40?img=1',  firstName: 'Mathilda', lastName:'bell' ,  phone: '(435) 474-3348', email: 'napozje@paw.com',   location: 'Karachi',   message: 'I am interested in buying a 3-bedroom apartment in Karachi. Please contact me at your earliest convenience.',  createdAt: '16 Mar 2022', replies: [] },
//   { id: 2,  avatar: null,                               firstName: 'Ryan ', lastName:'Stevens',    phone: '(804) 362-8940', email: 'leifden@podi.gov',  location: 'Lahore',    message: 'Looking for investment properties in DHA Lahore. Budget is around 2 crore.',                                 createdAt: '25 May 2022', replies: [] },
//   { id: 3,  avatar: 'https://i.pravatar.cc/40?img=5',  firstName: 'Loretta ', lastName:'Myers',   phone: '(513) 711-3369', email: 'kuw@rolluzdi.gov',  location: 'Islamabad', message: 'Need a rental house for my family of 4 in F-7. Please send available options.',                             createdAt: '18 Aug 2022', replies: [] },
//   { id: 4,  avatar: 'https://i.pravatar.cc/40?img=9',  firstName: 'Carrie ', lastName:'Aguilar',  phone: '(556) 616-5266', email: 'enval@maf.com',     location: 'Karachi',   message: 'Want to sell my plot in Gulshan-e-Iqbal. Size is 240 sq yards. Urgent sale.',                              createdAt: '12 Mar 2022', replies: [] },
//   { id: 5,  avatar: 'https://i.pravatar.cc/40?img=12', firstName: 'Marion ', lastName:'Rose',     phone: '(370) 928-5407', email: 'duv@wosapu.io',     location: 'Islamabad', message: 'Interested in commercial office space near Blue Area. Looking for 2000 sqft.',                            createdAt: '29 Sep 2022', replies: [] },
//   { id: 6,  avatar: null,                               firstName: 'Duane ', lastName:'Harrison',  phone: '(724) 447-9642', email: 'lum@rile.org',      location: 'Lahore',    message: 'Please share details of your new housing project in Bahria Town. Very interested.',                        createdAt: '18 Dec 2022', replies: [] },
//   { id: 7,  avatar: 'https://i.pravatar.cc/40?img=15', firstName: 'William ', lastName:'Curtis',  phone: '(373) 733-9486', email: 'lok@we.org',        location: 'Islamabad', message: 'My family is relocating from Karachi. Need a furnished house on rent for 6 months minimum.',               createdAt: '12 Sep 2022', replies: [] },
//   { id: 8,  avatar: 'https://i.pravatar.cc/40?img=20', firstName: 'Edwin ', lastName:'Hampton',   phone: '(702) 352-9481', email: 'be@haon.edu',       location: 'Karachi',   message: 'I would like a consultation regarding the current real estate market trends in Karachi.',                 createdAt: '12 May 2022', replies: [] },
//   { id: 9,  avatar: 'https://i.pravatar.cc/40?img=25', firstName: 'Sandra ', lastName:'Collins',  phone: '(612) 890-1234', email: 'scollins@xyz.com',  location: 'Lahore',    message: 'Looking for a villa with a garden in Model Town. Prefer 5 marla or above.',                              createdAt: '04 Jan 2023', replies: [] },
//   { id: 10, avatar: 'https://i.pravatar.cc/40?img=30', firstName: 'James ', lastName:'Patterson', phone: '(510) 234-5678', email: 'jpatterson@ab.com', location: 'Karachi',   message: 'Need guidance on home loan options for purchasing a property in Clifton.',                               createdAt: '19 Feb 2023', replies: [] },
// ];

// ─── View + Reply Modal ────────────────────────────────────────

const ViewModal = ({ contact, onClose, onReply }) => {
  const [replyText, setReplyText] = useState("");
  const [replySent, setReplySent] = useState(false);
  const [isSending, setIsSending] = useState(false);

  // Reset when contact changes
  useEffect(() => {
    setReplyText("");
    setReplySent(false);
    setIsSending(false);
  }, [contact?.id]);

  if (!contact) return null;


  const handleSend = () => {
    if (!replyText.trim()) return;

    setIsSending(true);

    onReply(contact.id, replyText.trim());

    setIsSending(false);
    setReplySent(true);
    setReplyText("");
  };



  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="cm-modal-overlay" onClick={onClose}>
      <div className="cm-modal-box" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="cm-modal-header">
          <h3 className="cm-modal-title">Contact Message</h3>
          <button className="cm-modal-close" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>

        <div className="cm-modal-body">
          {/* User Row */}
          <div className="cm-modal-user-row">
            {/* <div className="cm-modal-avatar">
              {contact.avatar
                ? <img src={contact.avatar} alt={contact.name} />
                : <span className="cm-avatar-fallback"><UserIcon /></span>}
            </div> */}
            <div>
              <p className="cm-modal-name">
                {contact.firstName} {contact.lastName}
              </p>
              <p className="cm-modal-date">Received on {contact.createdAt}</p>
            </div>
          </div>

          {/* Meta */}
          <div className="cm-modal-meta">
            <span className="cm-meta-item">
              <PhoneIcon />
              {contact.phone}
            </span>
            <span className="cm-meta-item">
              <MailIcon />
              {contact.email}
            </span>
            <span className="cm-meta-item">📍 {contact.location}</span>
          </div>

          {/* Original Message */}
          <div className="cm-modal-msg-wrap">
            <p className="cm-modal-msg-label">
              <MsgIcon /> Message
            </p>
            <p className="cm-modal-msg-text">{contact.message}</p>
          </div>

          {/* ── Previous Replies ── */}
          {contact.replies && contact.replies?.length > 0 && (
            <div className="cm-replies-list">
              <p className="cm-replies-heading">
                <ReplyIcon /> Sent Replies ({contact.replies?.length})
              </p>
              {contact.replies.map((r) => (
                <div key={r.id} className="cm-reply-bubble">
                  <div className="cm-reply-bubble-header">
                    <span className="cm-reply-from">You (Admin)</span>
                    <span className="cm-reply-time">{new Date(r.created_at).toLocaleDateString()}</span>
                  </div>
                  <p className="cm-reply-bubble-text">{r.reply}</p>
                </div>
              ))}
            </div>
          )}

          {/* ── Reply Box ── */}
          <div className="cm-reply-section">
            <p className="cm-reply-label">
              <ReplyIcon />
              Reply to {contact.firstName}
              {contact.lastName}
            </p>

            {/* Success toast */}
            {replySent && (
              <div className="cm-reply-success">
                <CheckIcon />
                Reply sent successfully to <strong>{contact.email}</strong>
              </div>
            )}

            <div className="cm-reply-input-wrap">
              <textarea
                className="cm-reply-textarea"
                placeholder={`Write your reply to ${contact.firstName} ${contact.lastName}…\n(Press Enter to send, Shift+Enter for new line)`}
                value={replyText}
                onChange={(e) => {
                  setReplyText(e.target.value);
                  setReplySent(false);
                }}
                onKeyDown={handleKeyDown}
                rows={3}
                disabled={isSending}
              />
              <div className="cm-reply-footer">
                <span className="cm-reply-hint">
                  Sending to: <strong>{contact.email}</strong>
                </span>
                <button
                  className={`cm-reply-send-btn ${replyText.trim() && !isSending ? "cm-reply-send-btn--active" : ""}`}
                  onClick={handleSend}
                  disabled={!replyText.trim() || isSending}
                >
                  {isSending ? (
                    <span className="cm-sending-dots">
                      <span />
                      <span />
                      <span />
                    </span>
                  ) : (
                    <>
                      <SendIcon /> Send Reply
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// ─── Delete Confirm Modal ──────────────────────────────────────
const DeleteModal = ({ contact, onClose, onConfirm }) => {
  if (!contact) return null;
  return (
    <div className="cm-modal-overlay" onClick={onClose}>
      <div
        className="cm-modal-box cm-modal-box--sm"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="cm-modal-header">
          <h3 className="cm-modal-title">Delete Contact</h3>
          <button className="cm-modal-close" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="cm-modal-body">
          <p className="cm-delete-msg">
            Are you sure you want to delete{" "}
            <strong>
              {contact.firstname}
              {contact.lastName}
            </strong>
            's message? This action cannot be undone.
          </p>
          <div className="cm-delete-actions">
            <button className="cm-btn-cancel" onClick={onClose}>
              Cancel
            </button>
            <button
              className="cm-btn-confirm-delete"
              onClick={() => {
                onConfirm(contact.id);
                onClose();
              }}
            >
              <TrashIcon /> Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// ─── Main Component ────────────────────────────────────────────
const ContactManagement = () => {
  const [contacts, setContacts] = useState();
  const [search, setSearch] = useState("");
  // const [locationFilter, setLocationfilter] = useState("");
  // const [filtered, setFiltered]           = useState(INITIAL_CONTACTS);
  const [filtered, setFiltered] = useState([]);
  const [viewContact, setViewContact] = useState(null);
  const [deleteContacts, setDeleteContacts] = useState();
  const [animatedCards, setAnimatedCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;
  const { baseUrl, authToken } = useContext(AppContext);
  const [location, setLocation] = useState();

  const locations = [...new Set(contacts?.map((c) => c.location))];

  useEffect(() => {
    [0, 1, 2].forEach((i) => {
      setTimeout(() => setAnimatedCards((prev) => [...prev, i]), i * 120);
    });
  }, []);
  const viewAllContacts = () => {
    setLoading(true);
    axios
      .get(`${baseUrl}/admin/contact/viewAllContacts`, {
        headers: {
          "Authorization": `Bearer ${authToken}`
        }
      })
      .then((response) => {
        console.log(response.data);
        setContacts(response.data.Allcontacts);
        setFiltered(response.data.Allcontacts);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    viewAllContacts();
  }, []);

  //delete
  const deleteContact = (contact) => {
    console.log("**********", contact);
    const formData = new FormData();
    formData.append("id", contact.id);

    axios
      .post(`${baseUrl}/admin/contact/deleteContacts`, formData, {
        headers: {
          "Content-Type": "multipart/formdata",
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        console.log(response.data);
        viewAllContacts();
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    let result = contacts;
    if (search.trim()) {
      const q = search.toLowerCase();
      result = result.filter(
        (c) =>
          c.name.toLowerCase().includes(q) ||
          c.email.toLowerCase().includes(q) ||
          c.phone.includes(q) ||
          c.message.toLowerCase().includes(q),
      );
    }
    if (location) result = result.filter((c) => c.location === location);
    setFiltered(result);
    setCurrentPage(1);
  }, [search, location, contacts]);

  // const handleDelete = (id) => {
  //   setContacts((prev) => prev.filter((c) => c.id !== id));
  // };

  // ── Reply handler — adds reply to contact's replies array ──

  const handleReply = (contactId, text) => {
  console.log("Reply Contact ID:", contactId);
  console.log("Reply Text:", text);

  const formData = new FormData();

  formData.append("excontactmgt_id", contactId);
  formData.append("reply", text);

  axios
    .post(`${baseUrl}/admin/contact/replyContact`, formData, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
    .then((response) => {
      console.log("Reply Response:", response.data);

      if (response.data.success) {
        const newReply = response.data.reply;

        // Modal ke andar immediately reply show karo
        setViewContact((prev) => ({
          ...prev,
          replies: [
            ...(prev?.replies || []),
            newReply,
          ],
        }));

        // Background mein contacts refresh karo
        viewAllContacts();
      }
    })
    .catch((error) => {
      console.log("Reply Error:", error);
    });
};



  const totalPages = Math.ceil(filtered?.length / itemsPerPage);
  const paginated = filtered?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  return (
    <AdminMasterLayout pageTitle="Contact Request">
      <div className="cm-page">
        {/* <div className="cm-page-header">
          <h2 className="cm-page-title">Contact Management</h2>
        </div> */}

        {/* Filters */}
        <div className="cm-filters-bar">
          <div className="cm-filters-left">
            <div className="cm-search-wrap">
              <SearchIcon />
              <input
                className="cm-search-input"
                type="text"
                placeholder="Search by name, email, phone or message…"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              {search && (
                <button
                  className="cm-search-clear"
                  onClick={() => setSearch("")}
                >
                  <CloseIcon />
                </button>
              )}
            </div>
            {/* <div className="cm-filter-dropdown">
              <span className="cm-filter-icon">📍</span>
              <select
                className="cm-filter-select"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
              >
                <option value="">All Locations</option>
                {locations.map((l) => (
                  <option key={l} value={l}>
                    {l}
                  </option>
                ))}
              </select>
              <span className="cm-dropdown-arrow">
                <ChevronIcon />
              </span>
            </div> */}
          </div>
        </div>

        {/* Table */}
        <div className="cm-table-card">
          <div className="cm-table-wrap">
            <table className="cm-table">
              <thead>
                <tr>
                  <th>firstName</th>
                  <th>lastName</th>
                  <th>Phone</th>
                  <th>Email</th>
                  <th>Location</th>
                  <th>Message</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="7" className="cm-loading-row">
                      <div className="cm-table-loading">
                        <div className="cm-table-loader"></div>
                        <p>Loading contact requests...</p>
                      </div>
                    </td>
                  </tr>
                ) : paginated?.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="cm-empty-row">
                      <div className="cm-empty-state">
                        <MsgIcon />
                        <p>No contacts found</p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  paginated?.map((c, idx) => (
                    <tr
                      key={c.id}
                      className="cm-table-row"
                      style={{ animationDelay: `${idx * 0.05}s` }}
                    >
                      <td>
                        <div className="cm-user-info">
                          {/* <div className="cm-avatar-wrap">
                        {c.avatar
                          ? <img src={c.avatar} alt={c.name} className="cm-avatar" />
                          : <span className="cm-avatar cm-avatar-fallback"><UserIcon /></span>}
                      </div> */}
                          <div>
                            <span className="cm-user-name">{c.firstName}</span>

                            {c.replies && c.replies.length > 0 && (
                              <span className="cm-replied-chip">Replied</span>
                            )}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="cm-user-info">
                          {/* <div className="cm-avatar-wrap">
                        {c.avatar
                          ? <img src={c.avatar} alt={c.name} className="cm-avatar" />
                          : <span className="cm-avatar cm-avatar-fallback"><UserIcon /></span>}
                      </div> */}
                          <div>
                            <span className="cm-user-name">{c.lastName}</span>
                            {c.replies && c.replies?.length > 0 && (
                              <span className="cm-replied-chip">Replied</span>
                            )}
                          </div>
                        </div>
                      </td>
                      <td className="cm-td-phone">{c.phone}</td>
                      <td className="cm-td-email">{c.email}</td>
                      <td>
                        <span className="cm-location-tag">{c.location}</span>
                      </td>
                      <td className="cm-td-msg">
                        <span className="cm-msg-preview">{c.message}</span>
                      </td>
                      <td>
                        <div className="cm-action-btns">
                          <button
                            className="cm-action-btn cm-view-btn"
                            title="View & Reply"
                            onClick={() => {
                              const latestContact = contacts?.find((item) => item.id === c.id);
                              setViewContact(latestContact || c);
                            }}
                          >
                            <EyeIcon />
                          </button>
                          <button
                            className="cm-action-btn cm-delete-btn"
                            title="Delete"
                            // onClick={() => setDeleteContacts(c)}>
                            onClick={() => deleteContact(c)}
                          >
                            <TrashIcon />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          <div className="cm-table-footer">
            <span className="cm-entries-info">
              Showing {paginated?.length} of {filtered?.length} entries
            </span>
            <div className="cm-pagination">
              <button
                className="cm-page-arrow"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((p) => p - 1)}
              >
                ‹
              </button>
              {Array.from({ length: totalPages }, (_, i) => (
                <button
                  key={i}
                  className={`cm-page-num ${currentPage === i + 1 ? "cm-page-active" : ""}`}
                  onClick={() => setCurrentPage(i + 1)}
                >
                  {i + 1}
                </button>
              ))}
              <button
                className="cm-page-arrow"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((p) => p + 1)}
              >
                ›
              </button>
            </div>
          </div>
        </div>

        <ViewModal
          contact={viewContact}
          onClose={() => setViewContact(null)}
          onReply={handleReply}
        />
        <DeleteModal
          contact={deleteContacts}
          onClose={() => setDeleteContacts(null)}
        // onConfirm={handleDelete}
        />
      </div>
    </AdminMasterLayout>
  );
};

export default ContactManagement;
